import { Icons } from "@caspeco/casper-ui-library";
import { PageType } from "logger/page-tracking";
import { usePageTracking } from "logger/use-page-tracking";
import { useTranslation } from "react-i18next";
import ErrorTemplate from "./error-template";
import { Routes } from "routes";

export default function SomethingWrong() {
    const { t } = useTranslation();

    usePageTracking({
        pageName: "SomethingWrongError",
        pageType: PageType.Page,
    });

    const storedSystemId = localStorage.getItem("lastKnownSystemId");
    const storedUnitId = localStorage.getItem("lastKnownUnitId");
    const isActivityRoute =
        localStorage.getItem("lastBookingRouteType") === Routes.ACTIVITY_BOOKING;
    const isExperienceView = localStorage.getItem("lastKnownIsExperienceView") === "true";
    const validStoredValues = storedSystemId && storedUnitId;

    const handleRefresh = () => {
        if (validStoredValues) {
            const activitySegment = isActivityRoute ? `/${Routes.ACTIVITY_BOOKING}` : "";
            const experienceSegment = isExperienceView ? `/${Routes.EXPERIENCE_VIEW}` : "";
            const path = `/${storedSystemId}/${storedUnitId}${activitySegment}${experienceSegment}`;
            // Use location.replace so the navigation and full-document reload
            // happen atomically on the target URL
            window.location.replace(path);
        }
    };

    return (
        <ErrorTemplate
            icon={Icons.SlightlySad}
            title={t("errorInformation.somethingWrong")}
            message={t("errorInformation.errorMessageWrong")}
            btnCallback={validStoredValues ? handleRefresh : undefined}
            btnText={t("errorInformation.tryAgain")}
            trackingId="error-something-wrong-try-again"
        />
    );
}
